import React from "react";
import Root from "./root";
import App from "./app";

export const wrapPageElement = ({ element, props }) => <App {...props}>{element}</App>;
export const wrapRootElement = ({ element }, options) => (
    <Root siteOptions={options}>{element}</Root>
);